import { render, staticRenderFns } from "./DocManual.vue?vue&type=template&id=c1ae9c8e&scoped=true"
import script from "./DocManual.vue?vue&type=script&lang=js"
export * from "./DocManual.vue?vue&type=script&lang=js"
import style0 from "./DocManual.vue?vue&type=style&index=0&id=c1ae9c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ae9c8e",
  null
  
)

export default component.exports